// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1r8JL","content":"ManualTimeModal_content__5VEwO"};